import {IEditorCanvas} from "@/customizer/interfaces";
import {IFabricCommonEventInfo, ITransform} from "@/editor/base/editor.interfaces";


export class FabricHelpers {
    public static clipContext(receiver:IEditorCanvas, ctx:CanvasRenderingContext2D):void {
        if (receiver.clipPath) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(receiver.clipPath.left || 0, receiver.clipPath.top || 0, receiver.clipPath.width || 0, receiver.clipPath.height || 0);
            ctx.clip();
        }
    }

    public static unClipContext(receiver:IEditorCanvas, ctx:CanvasRenderingContext2D):void {
        if (receiver.clipPath) {
            ctx.restore();
        }
    }
}

export function commonEventInfo(eventData:Event|null, target:fabric.Object, disableUndoManager?: boolean, trans?: ITransform, x?:number, y?:number) : IFabricCommonEventInfo {
    const transform:{target:fabric.Object} = trans || { target } ;
    transform.target = target;
    return {
        e: eventData,
        transform,
        disableUndoManager: disableUndoManager || false,
        pointer: {
            x: x,
            y: y,
        }
    };
}

export function getLocalMouse(transform:ITransform, localMouse:fabric.Point, zoom:number):fabric.Point {

    const target = transform.target;
    const padding = (target.padding || 0) / zoom;

    if (transform.originX === 'right') {
        localMouse.x *= -1;
    } else if (transform.originX === 'center') {
        localMouse.x *= transform.mouseXSign * 2;
        if (localMouse.x < 0) {
            transform.mouseXSign = -transform.mouseXSign;
        }
    }

    if (transform.originY === 'bottom') {
        localMouse.y *= -1;
    } else if (transform.originY === 'center') {
        localMouse.y *= transform.mouseYSign * 2;
        if (localMouse.y < 0) {
            transform.mouseYSign = -transform.mouseYSign;
        }
    }

    // adjust the mouse coordinates when dealing with padding
    if (Math.abs(localMouse.x) > padding) {
        if (localMouse.x < 0) {
            localMouse.x += padding;
        } else {
            localMouse.x -= padding;
        }
    } else { // mouse is within the padding, set to 0
        localMouse.x = 0;
    }

    if (Math.abs(localMouse.y) > padding) {
        if (localMouse.y < 0) {
            localMouse.y += padding;
        } else {
            localMouse.y -= padding;
        }
    } else {
        localMouse.y = 0;
    }

    return localMouse;
}

